module.exports = __webpack_public_path__ + "static/dendar-eldritch-pact-9368c9ed28421a6583e8cb33bd081a05.webp";